// extracted by mini-css-extract-plugin
module.exports = {"undoStyle":"_3MH5tuhH-lBUHF0uLD9QR_"};